import { Component, input, Input, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISystemIcons } from './system-icons';
import { v4 as uuid } from 'uuid';

@Component({
    selector: 'lib-system-icons',
    templateUrl: './system-icons.component.html',
    imports: [
      CommonModule
    ]
})
export class SystemIconsComponent {
  @Input() iconName: ISystemIcons['iconName'] = null;
  public readonly iconFill = input<string>();
  public readonly iconScale = input<number>(1);
  public readonly uuid = uuid();

  @HostBinding('style.transform') get hostTransform(): string | null {
    const s = this.iconScale();
    return s != null && s !== 1 ? `scale(${s})` : null;
  }

  @HostBinding('style.transform-origin') hostTransformOrigin = 'center center';
}
